define [], () ->
  (RentappService, $state, $filter) ->
    restrict: "E"
    template: require("./currency.jade")
    scope: {field: "=", mode: "@", index: "="}
    link: (scope, element, attrs) ->
      if scope.field.required and scope.mode == 'edit'
        scope.field_label = "#{scope.field.label}<span>&nbsp;*</span>"
      else
        scope.field_label = scope.field.label


// WEBPACK FOOTER //
// ./directives/freeforms/currency/currency.coffee